export const categoriesConst = [
    {name: 'Popular', iconClass:'icon-estrella'},
    {name: 'Nature', iconClass:'icon-planet-earth'},
    {name: 'ASMR', iconClass:'icon-kiss'},
    {name: 'Home', iconClass:'icon-home'},
    {name: 'City', iconClass:'icon-bloque-de-oficinas'},
    {name: 'Noise', iconClass:'icon-sound-frecuency'},
]
